import React from 'react';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '@/resources/strings/StringKeys';

const UserDashboardBanner = ({
  userStatus,
  userInfo,
  groupLocationSharing,
}) => {
  const userLocationTrackingPreference = userInfo?.locationPreference;
  const hasLocationIssue = userStatus?.hasDeviceLocationPermissionIssue();
  const hasNotificationIssue =
    userStatus?.hasDeviceNotificationPermissionIssue();

  const { t } = useTranslation();

  // Determine banner message
  const getBannerMessage = () => {
    if (hasLocationIssue && hasNotificationIssue) {
      return t(StringKeys.NOTIFICATION_AND_LOCATION_PERMISSION_WARNING);
    }
    if (hasLocationIssue) {
      return t(StringKeys.LOCATION_PERMISSION_WARNING);
    }
    if (hasNotificationIssue) {
      return t(StringKeys.NOTIFICATIONS_PERMISSION_WARNING);
    }
    if (groupLocationSharing === false) {
      return t(StringKeys.ADMIN_LOCATION_SHARING_WARNING);
    }
    if (
      groupLocationSharing === true &&
      userLocationTrackingPreference === 'emergency_only'
    ) {
      return t(StringKeys.WORKER_APP_LOCATION_SHARING_WARNING);
    }
    return null;
  };
  const bannerMessage = getBannerMessage();

  if (!bannerMessage) {
    return null;
  }

  return <Alert severity="warning">{bannerMessage}</Alert>;
};

export default UserDashboardBanner;
